import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { rServices } from '@/plugins/api';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import Nomination from '../list/nomination';
import { DEFAULT_NOMINATION } from '@/modules/Events/constants';
import NominationOptions from '../list/nomination-options';
import { getApiData, API_TYPES } from '@/utils/modelsApi';
import { ROLES } from '@/constants/roles';
import { DELETION_PROCESS_TYPE } from '../list/event-deletion-process';
import { deletionProcesses } from './deletion-processes';

const API_PATH = 'nominations';

const previewParams = ({ transfers = [], ...params } = {}) => transfers.reduce((query, transfer, index) => ({
  ...query,
  ...Object.fromEntries(Object.entries(transfer).map(([key, value]) => [`transfers[${index}][${key}]`, value ?? ''])),
}), params);

const deletionError = (error, obs) => {
  const validation = error?.response?.data?.errors || (!error?.response && (error?.data?.validation || error?.data?.errors));
  if (validation) obs?.setErrors(validation);
  return { error };
};

export const NominationsManager = {
  deletion: {
    ...deletionProcesses(DELETION_PROCESS_TYPE.nomination),
    preview({ args = [], params, obs } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.get(`event-nominations/${id}/deletion-preview`, previewParams(params)),
        (response) => ({ response, preview: response.data.data }),
        (error) => deletionError(error, obs),
        obs,
      );
    },
    start({ args = [], data, obs } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.delete(`event-nominations/${id}`, { data }),
        (response) => ({ response, processId: response.data.data.deletion_process_id }),
        (error) => deletionError(error, obs),
        obs,
      );
    },
  },
  objects: objectsRHandler(API_PATH, Nomination),

  get events() {
    const API_DATA = {
      [API_TYPES.private]: {
        path: 'event-nominations',
        get objects() {
          const { path } = this;
          return {
            ...objectsRHandler(path, Nomination),
            updateName({ args: [id] = [], data: { name }, obs } = DEFAULT_PARAMS) {
              return rHandler(
                apiService.put(`${path}/${id}/name`, { name: name?.trim() || null }),
                (response) => ({ response }),
                (error) => ({ error }),
                obs,
              );
            },
            async fullDelete({ args, data } = DEFAULT_PARAMS) {
              const [eventId, id] = args;
              // Убираем экспертов
              // const { response: expertsResponse } = await rServices.expertise.getExperts({ args: [eventId] });
              // const experts = (expertsResponse?.data?.data || []).filter((expert) => {
              //   const nominations = (expert?.nomination_ids || []).map((item) => item.nomination_id);
              //   return nominations.includes(id);
              // });
              // const expertsBullets = experts.map((expert) => {
              //   const params = {
              //     user_ids: [expert.id],
              //     nomination_ids: [id],
              //   };
              //   return rServices.expertise.detachExperts({ args: [eventId, params] });
              // });
              // // Убираем этапы
              // const { response: stagesResponse } = await rServices.events.getStages({ params: {
              //   'search[event_id]': eventId,
              //   'search[nomination_id]': id,
              // } });
              // const stages = stagesResponse.data?.data;
              // const stagesBullets = stages.map((stage) => rServices.events.deleteStage({ args: [stage.id] }));
              // await Promise.all([...expertsBullets, ...stagesBullets]);
              // Убираем номинацию
              return rHandler(
                apiService.delete(`${path}/${id}`, data),
                (response) => ({ response }),
                (error) => ({ error }),
              );
            },
          };
        },
      },
      [API_TYPES.public]: {
        path: 'public/event-nominations',
        get objects() {
          const { path } = this;
          return {
            ...objectsRHandler(path, Nomination),
          };
        },
      },
    };
    const PRIVATE_ROLES = Object.values(ROLES).filter((i) => i !== ROLES.guest);
    return getApiData(API_DATA, PRIVATE_ROLES).objects;
  },

  get options() {
    const API_DATA = {
      [API_TYPES.private]: {
        path: 'event-nomination-options',
        get objects() {
          const { path } = this;
          return {
            ...objectsRHandler(path, NominationOptions),
          };
        },
      },
      [API_TYPES.public]: {
        path: 'public/event-nomination-options',
        get objects() {
          const { path } = this;
          return {
            ...objectsRHandler(path, NominationOptions),
          };
        },
      },
    };
    const PRIVATE_ROLES = Object.values(ROLES).filter((i) => i !== ROLES.guest);
    return getApiData(API_DATA, PRIVATE_ROLES).objects;
  },

  all({ params } = DEFAULT_PARAMS) {
    return rHandler(
      apiService.get(API_PATH_EVENTS, params),
      (response) => ({
        response,
        items: response.data.data
          .map((nomination) => new Nomination(nomination, API_PATH_EVENTS))
          .filter(({ name }, _, arr) => (arr.length > 1 ? name !== DEFAULT_NOMINATION.NAME : true)),
      }),
      (error) => ({ error }),
    );
  },
};
